export const E_CONTRACT_FREE_LIMIT_CODE = 'E_CONTRACT_FREE_LIMIT_REACHED';

const DEFAULT_FREE_LIMIT = 3;

const quotaSource = (payload) => {
  if (!payload || typeof payload !== 'object') return null;
  return payload.quota || payload.usage || payload;
};

const toNonNegativeInteger = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  if (!Number.isSafeInteger(parsed) || parsed < 0) return null;
  return parsed;
};

const toBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  if (value === 1 || value === '1' || value === 'true') return true;
  if (value === 0 || value === '0' || value === 'false') return false;
  return null;
};

export const normalizeEContractQuota = (payload) => {
  const source = quotaSource(payload);
  if (!source) return null;

  const current = toNonNegativeInteger(source.current ?? source.used);
  const limit = toNonNegativeInteger(source.limit);
  const isPaid = toBoolean(source.is_paid ?? source.paid) ?? (source.limit === null ? true : null);
  const enforcementEnabled = toBoolean(source.enforcement_enabled);
  const canCreate = toBoolean(source.can_create) ?? (
    current !== null
    && isPaid !== null
    && enforcementEnabled !== null
    && (isPaid || !enforcementEnabled || (limit !== null && current < limit))
  );

  if (
    current === null
    || (!isPaid && limit === null)
    || typeof canCreate !== 'boolean'
    || isPaid === null
    || enforcementEnabled === null
  ) {
    return null;
  }

  return {
    current,
    limit,
    remaining: isPaid
      ? null
      : toNonNegativeInteger(source.remaining) ?? Math.max(limit - current, 0),
    can_create: canCreate,
    is_paid: isPaid,
    enforcement_enabled: enforcementEnabled,
  };
};

export const buildReachedEContractQuota = (payload, previousQuota = null) => {
  const source = quotaSource(payload) || {};
  const limit = toNonNegativeInteger(source.limit)
    ?? toNonNegativeInteger(previousQuota?.limit)
    ?? DEFAULT_FREE_LIMIT;
  const current = toNonNegativeInteger(source.current ?? source.used)
    ?? toNonNegativeInteger(previousQuota?.current)
    ?? limit;

  return {
    current: Math.max(current, limit),
    limit,
    remaining: 0,
    can_create: false,
    is_paid: false,
    enforcement_enabled: true,
  };
};

export const isEContractCreationBlocked = (quota) => Boolean(
  quota
  && quota.enforcement_enabled
  && !quota.is_paid
  && quota.can_create === false
);

export const canOpenOwnBilling = (user, clientId) => Boolean(
  user?.role === 'client_admin'
  && !user?.oem_id
  && user?.client_id != null
  && clientId != null
  && String(user.client_id) === String(clientId)
);
